export class PolygonHelper {
    static calculatePolygonArea = (coords: number[][]): number => {
        let area = 0;
        const n = coords.length;

        for (let i = 0; i < n; i++) {
            const j = (i + 1) % n;
            area += coords[i][0] * coords[j][1];
            area -= coords[j][0] * coords[i][1];
        }

        return Math.abs(area) / 2;
    };
}
